module.exports = __webpack_public_path__ + "static/media/ic-form.53e32495.svg";